import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';

import AddContentObjectContainer from '../../../pages/AddContentObject/AddContentObjectContainer';

const CreateObjectContentModal = ({ contentTypeName, testId = '' }) => {
  const [objectData, setObjectData] = useState();

  const afterSubmit = useCallback(({ success, contentObject }) => {
    if (success) setObjectData(contentObject);
  }, []);

  return (
    <AddContentObjectContainer
      contentTypeName={contentTypeName}
      id={objectData?.id}
      onSubmit={afterSubmit}
      testId={testId}
    />
  );
};

export default CreateObjectContentModal;

CreateObjectContentModal.propTypes = {
  /**
   * Content object type name
   */
  contentTypeName: PropTypes.string.isRequired,
  /**
   * Content object id
   */
  id: PropTypes.string,
  /**
   * Edit modal test id
   */
  testId: PropTypes.string,
  /**
   * Should the form have switches for enabling fields
   */
  isPatchable: PropTypes.bool,
};
